export const GetReadReceipt = (matrixEvent, matrixClient, ctxUseMatrixChatList) => {
    const room = matrixClient.getRoom(matrixEvent.getRoomId());
    const eventId = matrixEvent.getId();
    const senderId = matrixEvent.getSender();
    // Retrieve all users who read messages
    const receipts = room?.receiptCacheByEventId?.get(eventId) || [];

    const readBy = receipts.filter(
        r => r.type === "m.read" && r.userId !== senderId
    );
    // Find those users that has same room ID
    const roomData = ctxUseMatrixChatList?.activeChatList
        ?.find(val => val.matrixRoomId === matrixEvent.getRoomId());
    const users = roomData?.users || [];

    // Loop through users profile to get name and profile pic
    const usersProfile = readBy.map(({ userId }) => {
        const match = users.find(u => u.matrixUserId === userId);
        return {
            userId,
            firstName: match?.employeeDetails?.firstName,
            lastName: match?.employeeDetails?.lastName,
            profilePictureUrl: match?.employeeDetails?.profilePictureUrl || null,
        };
    });

    return {
        hasBeenRead: readBy.length > 0,
        usersProfile
    };
};
